export default {
    
    // ---------- AboutUs页面 ----------
    // "about_title": "关于我们",
    "about_desc": "利用先进的人工智能技术，为孩子们提供量身定制的互动故事。小程序根据每个小朋友的兴趣和喜好，创建独一无二的故事。在这些故事中，孩子们将遇见可爱的伙伴，一起探险、学习、成长",
    "about_company_name": "上海启扉绘梦智能科技有限公司",
    "dedicate.global.leader.platform":"致力于成为全球领先的儿童智能教育与陪伴平台",
    "company.profile":"公司成立于2024年3月，总部位于中国上海。公司专注于将儿童故事、绘本、音乐与智能科技相结合，通过创新的数字化产品和服务，为儿童提供优质的阅读体验。公司致力于利用人工智能等前沿科技，提升儿童的早期兴趣与教育，成为儿童陪伴式成长领域的领导者",
    "gongzhonghao":"公众号",
    "mini.program":"小程序",
    "relation.we.email":"联系我们邮箱:",
    "company.website.address":"网址:",
    "business.license":"营业执照:",
    "Record.Filing.Number":"备案号码:",
    "address":"地址:",
    "detailed.address":"详细地址",
  
    // ---------- HomePage页面 ----------
    "open.child.imaginary.world":"开启孩子的想象世界",
    "story.creation":"故事创作",
    "picture.book.creation":"绘本创作",
    "song.creation":"歌曲创作",
    "video.creation":"视频创作",
    "drawing.creation":"绘画创作",

    // ---------- coreFunction页面 ----------
    "Five.core.functions":"五大核心功能",
    "text.content1":"敲敲门童话通过AI技术将故事创作、绘本生成、音乐互动、动画制作与绘画工具融为一体， 激发儿童想象力与创造力，打造专属冒险与艺术成长体验",
    "story":"故事",
    "text.content2":"敲敲门童话——故事AI智能续写让孩子成为故事导演，每个敲击声都是灵感迸发，让想象力在「敲敲门」永不停歇",
    "picture.book":"绘本",
    "text.content3":"绘本一键生成奇妙世界，从《金发姑娘与三只熊》到恐龙星球，每本绘本都是孩子的专属冒险图鉴",
    "music":"音乐",
    "text.content4":"奥尔夫节奏唤醒沉睡的童话旋律，敲敲打打间，让《拍拍与敲敲》带孩子在音乐森林里蹦跶成长",
    "animation":"动画",
    "text.content5":"AI动画引擎让静态画作活起来，从《小蝌蚪找妈妈》到星际穿越，每一帧都是孩子眼中的奇幻宇宙",
    "maliang.drawing.board":"马良画板",
    "text.content6":"专为3-12岁儿童研发的智能创作工具，通过AI技术提升儿童的艺术表达能力与创造力发展",
   
    // ---------- Navbar页面 ----------
    "home.title": "首页",
    "core.function":"核心功能",
    "works.show":"作品展示",
    "correlation.product":"相关产品",
    "asRegards.we":"关于我们",
    
    // ---------- relatedProducts页面 ----------
    "our.multiport.platform.product":"我们的多端平台产品",
    "cross-platform":"轻松跨平台，实现多端联动交互，友好使用，精彩创作",
    "app.xiaochengxu":"APP/小程序",
    "projector":"投影仪",

    "maliang.drawing.ai.board":"马良AI画板—基于AI技术的儿童创作平台",
    "text.content7":"专为3-12岁儿童研发的智能创作工具，融合绘画、故事、音乐与语音交互功能，通过AI技术提升儿童的艺术表达能力与创造力发展",
    "text.content8":"AI实时辅助绘画自动补全涂鸦结构，一键生成动态作品（全平台），平板端独有画中话科普讲解",
    "text.content9":"智能分级推送万本绘本，1分钟生成定制故事（全平台适用）",
    "text.content10":"平板专属语音问答系统支持多角色互动，将知识转化为儿童易懂的趣味讲解",
    "text.content11":"家长端小程序独家支持远程同步创作，实时守护孩子创意成长",

    "knock.app.mini-program":"敲敲门童话App、小程序—基于AI技术的儿童创作与教育平台",
    "text.content12":"专为3-12岁儿童设计的开放式故事创作工具，通过“语音+多模态生成+硬件联动”技术，打造沉浸式创作体验，推动教育公平与创造力发展",
    "text.content13":"​智能生成互动故事绘本：智能生成动态互动故事，语音/触控定制剧情与插画",
    "text.content14":"AI配乐与音效生成：实时匹配故事生成情绪化音乐，触控调节节奏与立体声场",
    "text.content15":"​一键转化动画视频：一键转化故事为分镜动画，支持拖拽剪辑与4K投影播放",
    "text.content16":"多硬件无缝联动：手机/平板/投影仪自动适配分辨率与渲染模式",

    "knock.ai.baby.projector":"敲敲门童话—KnockAI宝宝盒投影仪",
    "projector.ai.partner":"智慧投影仪+AI绘本歌曲共创平台，孩子的第一个人工智能伙伴",
    "self-innovate.os":"自研KnockAI Story OS：自研底层内核技术,轻松进行故事、绘本、音乐、视频创作",
    "text.content17":"一键语音,轻松操控!：遥控器内置高精度语音识别系统，一键语音控制,操作更简单，使用更便捷",
    "text.content18":"AI智慧互动投影：海量绘本、歌曲免费畅享内容不间断更新，告别纸质绘本",
    "text.content19":"智慧投影+AI软件：搭载斯坦福团队研发AI软件,3~12岁儿童轻松AI创作键畅享海量绘本、歌曲",
   
    // ---------- worksShow页面 ----------
    "text.content20":"一起探索故事绘画的世界，看看你我的故事王国中，都有哪些惊奇冒险的故事",
  };